import { AxiosPromise } from 'axios';

import { Axios, AxiosService } from '@/services/Axios';
import { AllActivities } from '@/store/reducers/leads/types';
import { TaskCardVm } from '@/types';
import { OpenTasksCounterVm } from '@/types/backend/models/OpenTasksCounterVm';
import { queryParamsSerializer } from '@/utils/query-params-serializer';

import {
  ActivityDetailsData,
  activityDetailsDataFormatter,
  ActivityInstances,
} from './ActivityDetailsDataFormatter';
import { ACTIVITIES_PER_PAGE } from './constants';
import { AppliedActivityListFilters, AvailableDates, dateType, Params } from './types';

export class ActivityControllerClass {
  constructor(private APIService: AxiosService) {}

  fetchActivity = (id: string) => {
    return this.APIService.get(`/activities/${id}`);
  };

  fetchAllActivities = (filters: AppliedActivityListFilters): AxiosPromise<AllActivities> => {
    const params: Params = {};
    const { page, type, ...otherFilters } = filters as Params;

    // Activity List -> Tabs filter
    // All | Proposals | Projects | Orders
    const instancesMap = [undefined, [1, 2], [0], [3]];

    otherFilters.instances = instancesMap[type || 0];
    otherFilters.type = type === 3 ? 0 : otherFilters.instances?.[0];

    // Map filters to query params
    for (const key in otherFilters) {
      if ({}.hasOwnProperty.call(otherFilters, key)) {
        params[key] = otherFilters[key];
      }
    }

    // Add pagination
    params.pageNumber = page || 1;
    params.pageSize = ACTIVITIES_PER_PAGE;

    return this.APIService.get<AllActivities>(`/activities?${queryParamsSerializer(params)}`);
  };

  fetchTaskStatusesCards = (id: string): AxiosPromise<TaskCardVm[]> => {
    return this.APIService.get(`/activities/${id}/task-card-statuses`);
  };

  updateAlbumLink = (activityId: string, albumLink: string) => {
    return this.APIService.post('/activities/add-album-link', {
      activityId,
      albumLink,
    });
  };

  mapInstancesToDetailsData = (activityInstances: ActivityInstances): ActivityDetailsData => {
    return activityDetailsDataFormatter.format(activityInstances);
  };

  getAvailableDates = (activityId: string, dateType: dateType): AxiosPromise<AvailableDates> => {
    return this.APIService.get(`/activities/${activityId}/dateAvailability/${dateType}`);
  };

  getOpenTasksCounters = (): AxiosPromise<OpenTasksCounterVm> => {
    return this.APIService.get('/metrics/open-tasks');
  };
}

export const ActivityController = new ActivityControllerClass(Axios);
